export const MODULE_NAME = 'occupancy';
export const OCCUPANCY_KEY_PREFIX = 'OCCUPANCY_';
